<template>
	<checkout-block>
		<checkout-block-header>Sæson/turkort checkout</checkout-block-header>
		<checkout-block-body>
			<modal
				:visible="state1.modalVisible"
				:hideButton="true"
				:buttons="state1.modalButtons"
				headline="Kunne ikke finde dine oplysninger"
				@close="state1.modalVisible = false"
			>
				<p>
					Kunne ikke verificere din kode. Undersøg om du har skrevet koden
					korrekt!
				</p>
			</modal>
			<form @submit.prevent="validateMember()" class="flex mt-6 -mx-2">
				<label class="px-2 flex flex-col w-3/4">
					<div class="pb-2 font-bold">Sæson/turkortkode</div>
					<div>
						<input
							type="text"
							v-model="memberData.DiscountCode"
							ref="discountCode"
							placeholder="Indtast din sæsonkode"
							class="input-text w-full"
							@keyup="changeCode"
							@change="changeCode"
						/>
					</div>
				</label>

				<div class="w-1/3 pt-8">
					<button
						type="submit"
						class="border-gray-400 border rounded-sm text-base inline-flex items-center py-2 px-4 bg-transparent"
					>
						<spinner v-if="loading"></spinner>
						<span v-else>Bekræft</span>
					</button>
				</div>
			</form>

			<div
				v-if="
					memberData.ConfirmedDiscountCode &&
						memberData.DiscountId > 0 &&
						memberData.ConfirmedDiscountCode == memberData.DiscountCode
				"
			>
				<div class="flex -ml-2 mt-6">
					<label class="px-2 flex flex-col w-full md:w-1/2">
						<div class="pb-2 font-bold">Fornavn</div>
						<div>{{ memberData.ParticipantName }}</div>
					</label>

					<label class="px-2 flex flex-col w-full md:w-1/2">
						<div class="pb-2 font-bold">Fødselsdato</div>
						<div>{{ memberData.DateOfBirthMasked }}</div>
					</label>
				</div>

				<label class="inline-flex items-center font-normal mt-6">
					<input
						type="checkbox"
						class="form-checkbox text-top focus:outline-none w-6 h-6"
						v-model="memberData.Accepted"
						@change="[saveParticipantData()]"
					/>
					<span class="ml-2">
						Jeg bekræfter at ovenstående er mine personlige oplysninger.
					</span>
				</label>
			</div>
		</checkout-block-body>
	</checkout-block>
</template>

<script>
import debounce from "lodash/debounce";

export default {
	props: {
		memberData: Object,
		associationGuid: String
	},
	data: function() {
		return {
			loading: false,
			state1: {
				modalVisible: false,
				modalButtons: [
					{
						action: () => {
							this.state1.modalVisible = false;
							this.$refs["discountCode"].focus();
						},
						text: "Prøv igen",
						class:
							"border-gray-400 bg-white text-black px-4 py-2 ml-4 mb-2 border"
					}
				]
			}
		};
	},
	methods: {
		changeCode: function() {
			if (this.memberData.Accepted) {
				this.memberData.Accepted = false;
				this.$store.commit("updateMemberData", this.memberData);
				this.saveParticipantData();
			}
		},
		saveParticipantData: function() {
			this.$store.dispatch("saveBasket", this.$store.getters.basket);
		},
		validateMember: function() {
			this.loading = true;
			this.$store
				.dispatch("confirmMember", {
					discountCode: this.memberData.DiscountCode,
					associationId: this.associationGuid
				})
				.then(() => {
					if (this.memberData.DiscountId == 0) {
						this.state1.modalVisible = true;
					}
					this.loading = false;
				});
		}
	}
};
</script>
